import { ApolloError, useQuery } from '@apollo/client'
import { TargetBonusByEmployeeIdQuery, TargetBonusByEmployeeIdQueryVariables } from '../../../types'

import { TARGET_BONUS_BY_EMPLOYEE_ID } from '../Queries'

export default (
  employeeId: string,
  resigned = false,
): { data: TargetBonusByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    employeeResigned: resigned,
  }

  const { data, error, loading } = useQuery<TargetBonusByEmployeeIdQuery, TargetBonusByEmployeeIdQueryVariables>(
    TARGET_BONUS_BY_EMPLOYEE_ID,
    {
      variables: variables,
    },
  )

  return { data, error, loading }
}
